import styled from 'styled-components';

const StyledInput = styled.input.attrs({
	type: 'number',
	name: 'prop',
})`
	width: 120px;
	padding: 4px;
	text-align: center;

	&:focus {
		outline: none;
	}

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

export { StyledInput as ContentInputFloat };
